export type GroupedPriceState = {
  weekdayGroupPrice: number;
  weekendGroupPrice: number;
};

const toPriceNumber = (value: unknown): number => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

export const getGroupedPriceState = (source?: Record<string, any> | null): GroupedPriceState => ({
  weekdayGroupPrice: toPriceNumber(
    source?.weekday_group_price ?? source?.weekday_price ?? source?.friday_price ?? 0
  ),
  weekendGroupPrice: toPriceNumber(
    source?.weekend_group_price ?? source?.weekend_price ?? source?.holiday_price ?? 0
  ),
});

export const buildGroupedPricePayload = (
  source?: Partial<GroupedPriceState> | null
): Record<string, number> => {
  const weekdayGroupPrice = toPriceNumber(source?.weekdayGroupPrice ?? 0);
  const weekendGroupPrice = toPriceNumber(source?.weekendGroupPrice ?? 0);

  return {
    weekday_group_price: weekdayGroupPrice,
    weekend_group_price: weekendGroupPrice,
    weekday_price: weekdayGroupPrice,
    friday_price: weekdayGroupPrice,
    weekend_price: weekendGroupPrice,
    holiday_price: weekendGroupPrice,
  };
};
